import React, { useEffect } from "react";
import { Link } from "gatsby";
import LearnSitemap from "../Sitemaps/learnSitemap";
import NewsSitemap from "../Sitemaps/newsSitemap";
import GuidesSitemap from "../Sitemaps/guidesSitemap";
import BrandsSitemap from "../Sitemaps/brandsSitemap";
import HomeSitemap from "../Sitemaps/homeSitemap";
import { Icon } from "@herb/ui";
import { buildHerbAgencyUrl } from "@herb/utils/herbAgencyUrl";

const isBrowser = typeof window !== "undefined";

const Footer = ({ path }) => {
  const [activeTab, setActiveTab] = React.useState("/");
  const herbAgencyFooterUrl = buildHerbAgencyUrl({
    utmContent: "footer"
  });
  const pagePath = `${path}/`;
  const siloTitle = pagePath.match(/^\/learn\//)
    ? "learn"
    : pagePath.match(/^\/news\//)
    ? "news"
    : pagePath.match(/^\/guides\//)
    ? "guides"
    : pagePath.match(/^\/products\//)
    ? "brands"
    : "popular";

  useEffect(() => {
    const page = window.location.pathname.split("/");
    const classassigne = page[1] ? page[1] : "";
    setActiveTab(classassigne);
  }, []);

  return (
    <>
      <footer className="navFooter">
        <div className="footerContainer">
          <div className="footerLogo">
            <a className="footerImage" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="32"
                viewBox="0 0 34 32"
                fill="none"
              >
                <path
                  d="M0.151367 0H14.522L14.5384 0.0826318C14.4433 0.138821 14.3466 0.193358 14.25 0.247895C12.2066 1.3816 11.1169 3.14001 11.076 5.46857C11.0219 8.48464 11.0612 11.5023 11.0629 14.5201C11.0629 14.5845 11.0743 14.6473 11.0825 14.7415C12.09 14.7938 13.0997 14.6974 14.0796 14.4556C15.0627 14.2127 16.0131 13.897 16.9586 13.5615C18.7848 12.9159 20.7015 12.5683 22.6364 12.5319C22.715 12.5319 22.792 12.5187 22.91 12.5072V12.0642C22.91 9.92739 22.9231 7.79218 22.91 5.65532C22.8854 3.14001 21.7614 1.28245 19.487 0.165264C19.4303 0.129172 19.3756 0.0900016 19.3231 0.0479265H33.7986C33.6888 0.120642 33.6167 0.176832 33.538 0.21319C31.4177 1.37004 30.3002 3.15323 30.2952 5.58756C30.2821 12.489 30.2821 19.3909 30.2952 26.2934C30.2952 28.7724 31.3931 30.6002 33.5725 31.7686C33.638 31.805 33.7003 31.8496 33.8477 31.9339H19.2969C19.5902 31.7686 19.7885 31.6728 19.99 31.5538C21.8679 30.3969 22.8756 28.7129 22.8969 26.5017C22.9313 22.9254 22.9067 19.3474 22.9067 15.7678V15.3166C22.0186 15.4059 21.1551 15.4208 20.3259 15.5943C19.3169 15.8035 18.3245 16.0874 17.3568 16.4437C15.4563 17.1545 13.4529 17.5454 11.4266 17.6006C11.3218 17.6006 11.2185 17.6171 11.0563 17.6287V18.1046C11.0563 20.8001 11.0563 23.4972 11.0563 26.1943C11.0563 28.7261 12.1362 30.6217 14.386 31.8132C14.4384 31.8397 14.4843 31.8761 14.6236 31.9785C14.4335 31.9901 14.3499 32 14.2664 32H0.270986C0.23002 32 0.190694 32 0.151367 32V31.8959C0.208719 31.8628 0.26607 31.8298 0.32506 31.8C2.49786 30.6911 3.65635 28.9162 3.66455 26.4604C3.68421 19.4763 3.66455 12.4939 3.66455 5.50989C3.67677 4.75334 3.54012 4.00186 3.26252 3.29893C2.98491 2.59599 2.57185 1.95555 2.04724 1.41466C1.51961 0.854413 0.914959 0.375148 0.151367 0.165264V0Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#000"}`}
                />
              </svg>
            </a>
          </div>
          <div className="footerSvgs">
            <a
              href="https://www.instagram.com/herb/"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  className="footerBtnHover"
                  d="M12.0189 24C18.6412 24 24.0096 18.6274 24.0096 12C24.0096 5.37258 18.6412 0 12.0189 0C5.39671 0 0.0283203 5.37258 0.0283203 12C0.0283203 18.6274 5.39671 24 12.0189 24Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#3041ff"}`}
                />
                <path
                  d="M12.019 6.49373C13.8105 6.49373 14.025 6.49373 14.7331 6.53326C15.1592 6.53633 15.5813 6.61472 15.9801 6.7648C16.2691 6.87673 16.5315 7.04781 16.7507 7.26708C16.9698 7.48636 17.1407 7.749 17.2526 8.03819C17.4025 8.43731 17.4808 8.85982 17.4839 9.28621C17.5178 9.99491 17.5234 10.2095 17.5234 12.0024C17.5234 13.7954 17.5234 14.01 17.4839 14.7187C17.4808 15.1451 17.4025 15.5676 17.2526 15.9667C17.1407 16.2559 16.9698 16.5185 16.7507 16.7378C16.5315 16.9571 16.2691 17.1282 15.9801 17.2401C15.5813 17.3902 15.1592 17.4686 14.7331 17.4716C14.025 17.5055 13.8134 17.5112 12.019 17.5112C10.2246 17.5112 10.013 17.5112 9.30489 17.4716C8.87883 17.4686 8.45667 17.3902 8.05787 17.2401C7.77158 17.1256 7.51203 16.9531 7.2955 16.7335C7.07896 16.5139 6.91012 16.2519 6.79956 15.9638C6.64959 15.5647 6.57127 15.1422 6.56821 14.7159C6.53435 14.0071 6.52871 13.7926 6.52871 11.9996C6.52871 10.2067 6.52871 9.99209 6.56821 9.28338C6.57127 8.85699 6.64959 8.4345 6.79956 8.03539C6.91148 7.75016 7.08099 7.4911 7.2975 7.27442C7.51401 7.05774 7.77286 6.88809 8.05787 6.77608C8.45667 6.626 8.87883 6.54762 9.30489 6.54455C10.013 6.51067 10.2275 6.50502 12.019 6.50502V6.49373ZM12.019 5.29373C10.1964 5.29373 9.9679 5.29373 9.25129 5.33326C8.69395 5.34507 8.14262 5.45102 7.62056 5.64667C7.1711 5.81878 6.76293 6.08375 6.42265 6.4243C6.08236 6.76485 5.81761 7.17334 5.64563 7.62314C5.45014 8.14561 5.34426 8.69738 5.33247 9.25515C5.30143 9.97233 5.29297 10.201 5.29297 12.025C5.29297 13.849 5.29297 14.0777 5.33247 14.7949C5.35573 15.3455 5.47014 15.8884 5.67103 16.4015C5.843 16.8513 6.10776 17.2598 6.44804 17.6004C6.78832 17.9409 7.1965 18.2059 7.64595 18.378C8.16801 18.5736 8.71934 18.6796 9.27668 18.6914C9.99329 18.7224 10.2218 18.7309 12.0444 18.7309C13.867 18.7309 14.0955 18.7309 14.8121 18.6914C15.3694 18.6796 15.9208 18.5736 16.4428 18.378C16.8923 18.2059 17.3005 17.9409 17.6407 17.6004C17.981 17.2598 18.2458 16.8513 18.4178 16.4015C18.6133 15.879 18.7191 15.3273 18.7309 14.7695C18.762 14.0523 18.7704 13.8236 18.7704 11.9996C18.7704 10.1756 18.7704 9.94691 18.7309 9.22973C18.7191 8.67196 18.6133 8.12019 18.4178 7.59772C18.2458 7.14792 17.981 6.73943 17.6407 6.39888C17.3005 6.05833 16.8923 5.79336 16.4428 5.62125C15.9208 5.4256 15.3694 5.31965 14.8121 5.30784C14.0955 5.27679 13.867 5.26831 12.0444 5.26831L12.019 5.29373Z"
                  fill={`${activeTab === "videos" ? "#000" : "#F7FFE3"}`}
                />
                <path
                  d="M12.0189 8.54956C11.3371 8.54956 10.6705 8.75191 10.1035 9.13103C9.53657 9.51016 9.09467 10.049 8.83373 10.6795C8.57278 11.31 8.50451 12.0037 8.63754 12.673C8.77056 13.3423 9.09892 13.9571 9.58109 14.4397C10.0632 14.9222 10.6776 15.2508 11.3463 15.384C12.0151 15.5171 12.7083 15.4488 13.3383 15.1876C13.9683 14.9265 14.5067 14.4842 14.8856 13.9168C15.2644 13.3494 15.4666 12.6823 15.4666 11.9999C15.4666 11.0848 15.1034 10.2072 14.4568 9.56013C13.8102 8.91306 12.9333 8.54956 12.0189 8.54956ZM12.0189 14.239C11.5764 14.239 11.1439 14.1077 10.776 13.8616C10.408 13.6156 10.1213 13.2659 9.95194 12.8568C9.78261 12.4476 9.7383 11.9974 9.82463 11.5631C9.91095 11.1288 10.124 10.7298 10.4369 10.4167C10.7498 10.1035 11.1485 9.89026 11.5825 9.80386C12.0165 9.71747 12.4663 9.76182 12.8751 9.93129C13.2839 10.1008 13.6334 10.3877 13.8792 10.7559C14.125 11.1242 14.2563 11.5571 14.2563 11.9999C14.2563 12.5937 14.0205 13.1633 13.601 13.5832C13.1814 14.0031 12.6123 14.239 12.0189 14.239Z"
                  fill={`${activeTab === "videos" ? "#000" : "#F7FFE3"}`}
                />
                <path
                  d="M15.6018 9.22126C16.0475 9.22126 16.4087 8.85972 16.4087 8.41373C16.4087 7.96775 16.0475 7.6062 15.6018 7.6062C15.1562 7.6062 14.7949 7.96775 14.7949 8.41373C14.7949 8.85972 15.1562 9.22126 15.6018 9.22126Z"
                  fill={`${activeTab === "videos" ? "#000" : "#F7FFE3"}`}
                />
              </svg>
            </a>
            <a
              href="https://www.threads.net/@herb"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                aria-label="Threads"
                viewBox="0 0 192 192"
                xmlns="http://www.w3.org/2000/svg"
                width={25}
                height={24}
                class="threads"
              >
                <path
                  class="x19hqcy"
                  d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"
                ></path>
              </svg>
            </a>

            <a
              href="https://www.youtube.com/c/herbvideo"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  className="footerBtnHover"
                  d="M12.9809 24C19.6031 24 24.9715 18.6274 24.9715 12C24.9715 5.37258 19.6031 0 12.9809 0C6.35862 0 0.990234 5.37258 0.990234 12C0.990234 18.6274 6.35862 24 12.9809 24Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#3041ff"}`}
                />
                <path
                  d="M19.6961 14.6822C19.6946 15.1909 19.492 15.6784 19.1325 16.0382C18.7731 16.3979 18.2859 16.6007 17.7776 16.6022H8.1851C7.67674 16.6007 7.18963 16.3979 6.83016 16.0382C6.47069 15.6784 6.26809 15.1909 6.2666 14.6822V9.31746C6.26809 8.8087 6.47069 8.32121 6.83016 7.96146C7.18963 7.60171 7.67674 7.39895 8.1851 7.39746H17.7776C18.2859 7.39895 18.7731 7.60171 19.1325 7.96146C19.492 8.32121 19.6946 8.8087 19.6961 9.31746V14.6822ZM11.5932 13.6431L15.2243 11.7626L11.5932 9.88216V13.6431Z"
                  fill={`${activeTab === "videos" ? "#000" : "#F7FFE3"}`}
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/herb"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  className="footerBtnHover"
                  d="M12.9623 24C19.5845 24 24.9529 18.6274 24.9529 12C24.9529 5.37258 19.5845 0 12.9623 0C6.34007 0 0.97168 5.37258 0.97168 12C0.97168 18.6274 6.34007 24 12.9623 24Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#3041ff"}`}
                />
                <path
                  d="M18.7975 5.43832H7.12851C6.93695 5.43832 6.75324 5.51448 6.61779 5.65003C6.48234 5.78559 6.40625 5.96944 6.40625 6.16114V17.8393C6.40625 18.031 6.48234 18.2148 6.61779 18.3504C6.75324 18.4859 6.93695 18.5621 7.12851 18.5621H13.4116V13.4797H11.6934V11.5033H13.4031V10.0407C13.4031 8.34655 14.4357 7.42325 15.9423 7.42325C16.4522 7.42135 16.9617 7.44776 17.4686 7.50232V9.27268H16.4219C15.5981 9.27268 15.4401 9.66514 15.4401 10.2383V11.5033H17.415L17.1583 13.4797H15.4655V18.5621H18.8088C19.0003 18.5621 19.184 18.4859 19.3195 18.3504C19.4549 18.2148 19.531 18.031 19.531 17.8393V6.16114C19.531 6.06526 19.512 5.97033 19.475 5.88189C19.438 5.79345 19.3838 5.71327 19.3155 5.646C19.2473 5.57873 19.1663 5.52571 19.0774 5.49006C18.9884 5.4544 18.8933 5.43682 18.7975 5.43832Z"
                  fill={`${activeTab === "videos" ? "#000" : "#F7FFE3"}`}
                />
              </svg>
            </a>
            <a
              href="https://open.spotify.com/playlist/7DkimKAKZwHqhEWLPSwwFb"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  className="footerBtnHover"
                  d="M12.7187 0.000180005C6.0914 0.000180005 0.71875 5.37278 0.71875 12.0002C0.71875 18.6278 6.0914 24.0002 12.7187 24.0002C19.3466 24.0002 24.7188 18.628 24.7188 12.0002C24.7188 5.37314 19.3466 0.000720018 12.7185 0.000720018L12.7187 0V0.000180005ZM18.2218 17.3078C18.0069 17.6602 17.5456 17.7722 17.1929 17.5557C14.3756 15.8346 10.8287 15.4449 6.65157 16.3993C6.24908 16.4909 5.84786 16.2387 5.75606 15.8361C5.6639 15.4334 5.91518 15.0322 6.31874 14.9406C10.8899 13.8962 14.8108 14.3458 17.974 16.2789C18.3266 16.4953 18.4384 16.9552 18.2218 17.3078ZM19.6906 14.0404C19.4197 14.4805 18.8437 14.6194 18.4038 14.3487C15.1782 12.366 10.2615 11.7917 6.44618 12.9501C5.95136 13.0995 5.42882 12.8206 5.2787 12.3267C5.12966 11.8319 5.40866 11.3104 5.90258 11.1599C10.2606 9.83761 15.6784 10.4781 19.3826 12.7544C19.8226 13.0253 19.9615 13.6013 19.6908 14.0407V14.0405L19.6906 14.0404ZM19.8168 10.6379C15.9491 8.34069 9.56829 8.12955 5.87576 9.25025C5.28284 9.43008 4.65572 9.09545 4.47608 8.50233C4.29644 7.90904 4.63088 7.28244 5.22416 7.10226C9.46299 5.81541 16.5095 6.06399 20.9623 8.70754C21.4967 9.02417 21.6717 9.71286 21.3549 10.2455C21.0395 10.7789 20.3489 10.9547 19.8173 10.6379H19.8168Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#3041ff"}`}
                />
              </svg>
            </a>
            <a
              href="https://twitter.com/Herbworthy"
              target="_blank"
              className="socialSvg"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <path
                  className="footerBtnHover"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M32.6172 16C32.6172 24.8366 25.4537 32 16.6172 32C7.78063 32 0.617188 24.8366 0.617188 16C0.617188 7.16344 7.78063 0 16.6172 0C25.4537 0 32.6172 7.16344 32.6172 16ZM24.665 13.4638C24.665 18.5598 20.785 24.4398 13.689 24.4398C11.513 24.4398 9.48097 23.7998 7.79297 22.6958C8.09697 22.7358 8.40097 22.7518 8.71297 22.7518C10.521 22.7518 12.185 22.1358 13.505 21.1038C11.817 21.0718 10.393 19.9598 9.90497 18.4238C10.145 18.4718 10.385 18.4958 10.633 18.4958C10.985 18.4958 11.329 18.4478 11.649 18.3598C9.88097 17.9998 8.55297 16.4478 8.55297 14.5758V14.5278C9.07297 14.8158 9.66497 14.9918 10.297 15.0078C9.25697 14.3198 8.57697 13.1358 8.57697 11.7998C8.57697 11.0958 8.76897 10.4318 9.09697 9.86383C11.001 12.1998 13.841 13.7358 17.049 13.8958C16.977 13.6158 16.945 13.3198 16.945 13.0158C16.945 10.8878 18.673 9.15983 20.801 9.15983C21.913 9.15983 22.913 9.62383 23.617 10.3758C24.497 10.1998 25.321 9.87983 26.065 9.43983C25.777 10.3438 25.169 11.0958 24.369 11.5758C25.153 11.4798 25.897 11.2718 26.585 10.9678C26.065 11.7438 25.409 12.4238 24.657 12.9678C24.665 13.1278 24.665 13.2958 24.665 13.4638Z"
                  fill={`${activeTab === "videos" ? "#fff" : "#3041ff"}`}
                />
              </svg>
            </a>
          </div>
          <div className="footerMenu">
            <div className="footerLinks">
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/privacy"
              >
                privacy
              </Link>
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                href={herbAgencyFooterUrl}
                to="/tos"
              >
                terms
              </Link>
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/faq"
              >
                faq
              </Link>
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/about-us"
              >
                about
              </Link>
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/dispensaries"
              >
                dispensaries
              </Link>
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                href={herbAgencyFooterUrl}
              >
                advertise with herb
              </Link>
              <Link className={`${activeTab === "videos" ? "fnLinksVideos" : "fnLinks"}`}
                to="/create-with-herb">create with herb</Link>

              {/* <Link
              className={`${
                activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
              }`}
              to="/"
            >
              contact
            </Link> */}
              <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/newsletters"
              >
                newsletters
              </Link>
              {/* <div
                className="fnLinksSitemap"
                onClick={() => {
                  const element = document.querySelector(".siteMapOverlay");
                  element.style.display = "block";
                }}
              >
                {siloTitle}
              </div>
              <div className="siteMapOverlay">
                <div className="siteMapModal">
                  <div className="closeBtn">
                    <h2 className="innerTitle">{siloTitle}</h2>
                    <div
                      onClick={() => {
                        const element = document.querySelector(
                          ".siteMapOverlay"
                        );
                        element.style.display = "none";
                      }}
                    >
                      <Icon
                        icon="close"
                        height={24}
                        width={24}
                        viewBox={"0 0 24 24"}
                      />
                    </div>
                  </div>
                  <div className="dropUpSitemap">
                    {siloTitle === "learn" ? (
                      <LearnSitemap />
                    ) : siloTitle === "guides" ? (
                      <GuidesSitemap />
                    ) : siloTitle === "brands" ? (
                      <BrandsSitemap />
                    ) : siloTitle === "news" ? (
                      <NewsSitemap />
                    ) : (
                      <HomeSitemap />
                    )}
                  </div>
                </div>
              </div> */}
               <Link
                className={`${
                  activeTab === "videos" ? "fnLinksVideos" : "fnLinks"
                }`}
                to="/sitemap"
              >
                sitemap
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
